<template>
   <ClientOnly>
   <nav
     class="px-3 sticky-toolbar bg-white py-12"
     v-show="isMobileToolbarVisible"
   >
       <nuxt-link class="btn xsmaller-btn btn-solid-primary-600 d-flex align-items-center justify-content-center fsz-14 w-100"
          @click="handleAddAnnounce"
        >
          <span class="material-symbols-rounded fsz-20 me-1">add</span>
            Ajouter une annonce
        </nuxt-link>
    </nav>
   </ClientOnly>
  <main class="page-container">
                   
    <section class="bg-img landing-page-bg bg-primary-600 pt-80 position-relative">
      <div class="hero-bg">
        <NuxtImg
          src="/backgrounds/Topauto_-_BG.png"
          alt="TopAuto background"
          preload
          fetchpriority="high"
          loading="eager"
          decoding="async"
          format="webp"
          style="width:100%;height:100%;object-fit:cover;"
        />
      </div>
      <div class="container-xl d-flex align-items-center justify-content-center flex-row flex-wrap gap-4">
        <h1 class="display-2 text-white text-center mt-3 mt-lg-40 fw-bold home-title">
          Trouvez votre voiture idéale en Tunisie
        </h1>
        <ClientOnly>
          <nuxt-link class="gradient-border-btn text-primary-600 fsz-16 d-lg-none"
            @click="handleAddAnnounce"
          >
            <span class="material-symbols-rounded fsz-24 me-1">add</span>
            Ajouter une annonce
          </nuxt-link>
        </ClientOnly>
      </div>
    </section>
    
    <section class="bg-white">
      <ClientOnly>
        <LazyPanelsSearchBar />
        <template #fallback>
          <HomeSearchSkeleton />
        </template>
      </ClientOnly>

      <div class="container-xxl fillter-card-container py-40 px-3 px-xl-0">
        <div class="d-flex flex-column gap-4 justify-content-center">
          <div class="text-center pb-2">
            <h2 class="h3">Nos catégories les plus recherchées</h2>
            <p>
              Explorez les sélections prisées, trouvez ce que vous cherchez facilement
            </p>
          </div>
          <div class="d-flex justify-content-center">
            <ClientOnly>
              <div class="d-flex flex-wrap justify-content-center" style="gap: 20px;">
                <nuxt-link class="d-flex flex-column align-items-center justify-content-center"
                  v-for="(carType, index) in filteredCarsType"
                  :to="{path: '/voitures', query: {categories: carType.key}}"
                  :key="index"
                >
                  <div v-if="!carType.name.includes('Autres')"
                    class="card-fillters d-flex flex-column align-items-center justify-content-center"
                    :class="{ 'small-width': width < 372 }"
                    @mouseover="hoveredIndex = index"
                    @mouseleave="hoveredIndex = -1">
                    <img :src="getCarTypeImage(carType, index)" :alt="carType.name" class="markIcon" style="scale: 0.85;"/>
                    <p class="mt-2 fsz-14 title-limitation">{{ carType.name }}</p>
                  </div>
                </nuxt-link>
              </div>
              <template #fallback>
                <HomeCategoriesSkeleton :count="homeCategorySkeletonCount" />
              </template>
            </ClientOnly>
          </div>
        </div>
      </div>
    </section>
    
    <section style="background-color: #F9F9FB;">
      <div class="container-xl py-40 px-3 px-xl-0">
        <div class="text-center pb-32">
          <h2 class="h3">À la une</h2>
          <p>
            Explorez les tout derniers voitures et découvrez les nouveautés
          </p>
        </div>
        <div v-if="!hydrated" class="w-100">
          <CardsSkeleton
            :count="homeCardsSkeletonCount"
            view="grid"
            grid-class="grid-cards-container grid-cards-container-home"
          />
        </div>
        <div v-else-if="!hasHomeResults" class="w-100 text-center">
          <span class="spinner-border text-primary-600 mt-4" role="status"></span>
          <p>Chargement en cours, merci de patienter.</p> 
        </div>
        <ClientOnly>
          <LazyCarCards
            v-if="hasHomeResults"
            :data="visibleAnnouncements"
            :isHome="true"
            :className="'grid-cards-container-home'"
            v-slot="slotProps"
          >
            <LazyCarCard
              :hasStatus="true"
              :announce="slotProps.add"
              :key="slotProps.add.id"
              :grid-view="true"
              :isHome="slotProps.isHome"
            />
          </LazyCarCards>
        </ClientOnly>
        <div class="d-flex justify-content-center mt-32">
          <NuxtLink class="btn px-4 py-12 btn-solid-primary-600 d-flex align-items-center justify-content-center medium-btn fsz-14 col-12 col-sm-auto" to="/voitures" @click.prevent="handleGoToSearchResults">
            <span class="material-symbols-rounded fsz-20 me-1">add</span>
            Plus de véhicules
          </NuxtLink>
        </div>
      </div>
    </section>
    
    <section class="bg-primary-600 home-info-cards">
      <div class="container-xl py-40 px-xl-0 infoCards-container">
        <div class="text-center pb-32">
          <h2 class="h3 text-white">
            Vendez votre voiture en toute simplicité
          </h2>
          <p class="text-white">
            Publiez votre annonce gratuitement et trouvez un acheteur en un temps record.
          </p>
        </div>
        <ul class="list-unstyled row d-flex justify-content-center align-items-center">
          <li v-for="(item, index) in content" :key="index"
            class="col-sm-5 col-xl-3 d-flex flex-column flex-xl-row align-items-center gap-2 px-lg-4 px-xl-1">
            <div class="influo-cards">
              <div class="card-avatar mx-auto">
                <span class="material-symbols-rounded fsz-20">{{ item.icon }}</span>
              </div>
              <h6 class="mt-2">{{ item.title }}</h6>
              <p class="fsz-12 mt-2">
                {{ item.discription }}
              </p>
            </div>
            <span v-if="index !== 3" :class="index === 2 ? 'd-xl-block d-sm-none' : 'd-block'" class="circlesSvg">
              <svg xmlns="http://www.w3.org/2000/svg" width="43" height="8" viewBox="0 0 43 8">
                <g id="Group_90" data-name="Group 90" transform="translate(-624 -1646.99)">
                  <circle id="Ellipse_6" data-name="Ellipse 6" cx="4" cy="4" r="4" transform="translate(624 1646.99)"
                    fill="#E6EAF0" />
                  <circle id="Ellipse_7" data-name="Ellipse 7" cx="4" cy="4" r="4" transform="translate(636 1646.99)"
                    fill="#E6EAF0" opacity="0.697" />
                  <circle id="Ellipse_8" data-name="Ellipse 8" cx="4" cy="4" r="4" transform="translate(647 1646.99)"
                    fill="#E6EAF0" opacity="0.449" />
                  <circle id="Ellipse_9" data-name="Ellipse 9" cx="4" cy="4" r="4" transform="translate(659 1646.99)"
                    fill="#E6EAF0" opacity="0.302" />
                </g>
              </svg>
            </span>
          </li>
        </ul>
        <LazyDialogsToast />
        <div class="d-flex justify-content-center mt-32">
          <NuxtLink class="btn btn-outline-primary-600 sell-now-btn py-12 d-flex align-items-center justify-content-center medium-btn fsz-14" to="/listing-form">
            <span class="material-symbols-rounded fsz-18 me-1">arrow_forward</span>
            Vendre ma voiture maintenant
          </NuxtLink>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { trackAnnouncementStarted } from '~/composables/useFirebaseAnalytics'
import { breakpoints } from '~/utils/breakpoints.js';
import { useSearchStore } from "~/store/useSearchHome";
import { carsType } from "~/utils/cars_options";
import { useWindowScroll, throttleFilter } from "@vueuse/core";
import {
  getDisplayedPromotedIds,
  isPromotedAnnouncement,
  getUniquePromotedAnnouncements,
  mergePromotedAnnouncements,
} from "~/utils/promotedResults";
import CardsSkeleton from "~/components/Skeletons/CardsSkeleton.vue";
import HomeSearchSkeleton from "~/components/Skeletons/HomeSearchSkeleton.vue";
import HomeCategoriesSkeleton from "~/components/Skeletons/HomeCategoriesSkeleton.vue";

const dashStore = useDashboardStore();
const route = useRoute();
const router = useRouter();
const runTimeConfig = useRuntimeConfig();
const { sendAddAnnouncementTelegram } = useAddAnnouncementTelegram();
const { $fbq } = useNuxtApp()
const BACK_SKIP_KEY = 'topauto:skip-search-refetch-on-back';
const hoveredIndex = ref(-1);
const { width } = useWindowSize();
const { resolvedTheme } = useTheme();
const isDarkTheme = computed(() => resolvedTheme.value === 'dark');
const hydrated = ref(false);
const homeCardsSkeletonCount = computed(() => {
  if (!hydrated.value) return 10;
  const currentWidth = width.value || breakpoints.screen_desktop;
  if (currentWidth >= breakpoints.screen_laptop) return 12;
  if (currentWidth >= breakpoints.screen_mobile) return 6;
  return 10;
});
const homeCategorySkeletonCount = computed(() => {
  if (!hydrated.value) return 6;
  const currentWidth = width.value || breakpoints.screen_desktop;
  return currentWidth < breakpoints.screen_mobile ? 6 : 8;
});

// Throttle scroll events for better performance
const { y: scrollY } = useWindowScroll({
  eventFilter: throttleFilter(100),
});
const isMobileToolbarVisible = computed(() => scrollY.value > 220 && width.value < breakpoints.screen_tablet);

definePageMeta({
  layout: "home-layout",
  scrollRestoration: true,
  keepScroll: true,
});

const searchStore = useSearchStore();
const homePromotedAnnouncements = ref([]);
const { markReady, resetReady } = useScrollRestoration();
const icons = reactive({
  arrow: 'arrow_forward',
  camera: 'photo_camera',
  plus: 'add',
  car: 'directions_car',
  chat: 'sms',
  dollarOutline: 'payments',
});

const content = reactive([
  {
    icon: icons.camera,
    title: 'Préparation',
    discription: 'Préparez votre véhicule pour la vente en rassemblant toutes les informations et documents nécessaires.'
  },
  {
    icon: icons.car,
    title: 'Création de l’annonce',
    discription: 'Utilisez notre interface conviviale pour créer une annonce détaillée qui met en valeur les caractéristiques uniques de votre voiture.'
  },
  {
    icon: icons.chat,
    title: 'Visite',
    discription: 'Attirez des acheteurs potentiels grâce à une visibilité maximale. Les intéressés peuvent explorer votre annonce en détail et prendre contact avec vous.'
  },
  {
    icon: icons.dollarOutline,
    title: 'Vente',
    discription: 'Finalisez la transaction en toute sécurité. Notre plateforme facilite le processus, de la négociation à la conclusion de la vente, pour une expérience fluide et transparente.'
  },
]);
const mergedHomeAnnouncements = computed(() => {
  const normal = searchStore.getFetchResult?.announcements ?? [];
  const promoted = getUniquePromotedAnnouncements(
    homePromotedAnnouncements.value
  ).slice(0, 2);
  return mergePromotedAnnouncements(normal, promoted, 20, 2);
});

const isAnnouncementDetailsPath = (value) => /\/voitures\/[^/]+\/[^/]+\/\d+/.test(String(value || ''));
const isComingFromAnnouncementDetails = () => {
  if (!process.client) return false;
  const historyState = router.options.history.state || {};
  return isAnnouncementDetailsPath(historyState.back) || isAnnouncementDetailsPath(historyState.forward);
};

const consumeSkipRefetchFlag = () => {
  if (!process.client) return false;
  const shouldSkip = sessionStorage.getItem(BACK_SKIP_KEY) === '1';
  if (shouldSkip) {
    sessionStorage.removeItem(BACK_SKIP_KEY);
  }
  return shouldSkip;
};

const hydrateHomePromotedFromCache = () => {
  const cachedPromotedFromStore = getUniquePromotedAnnouncements(
    searchStore.getPromotedSearchResult ?? []
  ).slice(0, 2);

  if (cachedPromotedFromStore.length) {
    homePromotedAnnouncements.value = cachedPromotedFromStore;
    return;
  }

  const cachedAnnouncements = searchStore.getFetchResult?.announcements ?? [];
  const cachedPromoted = cachedAnnouncements.filter((item) =>
    isPromotedAnnouncement(item)
  );

  const hydratedPromoted = getUniquePromotedAnnouncements(cachedPromoted).slice(0, 2);
  homePromotedAnnouncements.value = hydratedPromoted;
  if (hydratedPromoted.length) {
    searchStore.setPromotedSearchResult(hydratedPromoted);
  }
};

const hasHomeResults = computed(() =>
  hydrated.value && Boolean(mergedHomeAnnouncements.value.length)
);

const handleAddAnnounce = () => {
  if (dashStore.getUserProfil.id) {
    void sendAddAnnouncementTelegram('manuel')
    trackAnnouncementStarted({ announce_type_created: 'Manuel' })
    navigateTo('/listing-form/vehicle-data?fresh=true')
  } else {
    navigateTo('authentication/signup')
  }
}

const getCarTypeImage = (carType, index) => {
  if (isDarkTheme.value) {
    return carType.hoverImage;
  }
  return hoveredIndex.value === index ? carType.hoverImage : carType.image;
};

// Memoize the filtered cars type
const filteredCarsType = computed(() => {
  const w = width.value;
  return carsType.filter((carType) => {
    if (w < breakpoints.screen_smallMobile || (w >= 1092 && w < 1275)) {
      return carType.name !== 'Camionnette' && carType.name !== 'Cabriolet';
    }
    else if (w >= 1275 && w < 1440) {
      return carType.name !== 'Cabriolet';
    }
    else {
      return true;
    }
  });
});

// Memoize the visible announcements
const visibleAnnouncements = computed(() => {
  if (!mergedHomeAnnouncements.value.length) return [];
  
  const w = width.value;
  let count = 10; // valeur par défaut (mobile)

  if (w >= breakpoints.screen_laptop) {
    count = 12;
  } else if (w >= breakpoints.screen_mobile) {
    count = 6;
  }
  return mergedHomeAnnouncements.value.slice(0, count);
});

const seoUrl = ref();
const seoImage = ref();

const seoTitle = `Voitures d’occasion en Tunisie | TopAuto - Annonces Auto Gratuites`;
const seoDescription = `Achetez ou vendez votre voiture d’occasion en Tunisie sur TopAuto. Des milliers d’annonces vérifiées, de particuliers et de professionnels. Trouvez la vôtre dès aujourd’hui !`;
seoUrl.value = `${runTimeConfig.public.clientBaseUrl}${route.fullPath}`;
seoImage.value = `${runTimeConfig.public.clientBaseUrl}/_nuxt/assets/images/logos/Logo.png`;

useHead({
  title: seoTitle,
  link: [
    {
      rel: 'canonical',
      href: runTimeConfig.public.clientBaseUrl
    }
  ],
  meta: [
    {
      name: 'robots',
      content: 'index, follow'
    },
    {
      name: 'description',
      content: seoDescription
    },
    {
      property: 'og:title',
      content: seoTitle
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:description',
      content: seoDescription
    },
    {
      property: 'og:url',
      content: seoUrl
    },
    {
      property: 'og:image',
      content: seoImage
    },
    {
      property: 'og:site_name',
      content: 'TopAuto'
    }
  ]
});

useSchemaOrg([
  defineWebSite({
    name: 'TopAuto',
    description: seoDescription,
    url: seoUrl.value,
    image: seoImage.value,
  }),
  defineWebPage({
    name: seoTitle,
    description: seoDescription,
    url: seoUrl.value,
    image: seoImage.value,
  }),
  defineOrganization({
    name: 'TopAuto',
    url: runTimeConfig.public.clientBaseUrl,
    logo: seoImage.value,
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        name: 'Accueil',
        item: runTimeConfig.public.clientBaseUrl,
      },
    ],
  }),
]);

const buildPromotedPayload = () => {
  let payload = {};
  const selectedMakes = Array.isArray(searchStore.userInput?.makes)
    ? searchStore.userInput.makes
    : [];
  const selectedModels = Array.isArray(searchStore.userInput?.models)
    ? searchStore.userInput.models
    : [];

  const makesIds = selectedMakes
    .map((make) => make?.id)
    .filter((id) => typeof id === 'number');
  const modelsIds = selectedModels
    .map((model) => model?.id)
    .filter((id) => typeof id === 'number');

  if (makesIds.length) payload.makesIds = makesIds;
  if (modelsIds.length) payload.modelsIds = modelsIds;

  payload = {
    ...payload,
    ...searchStore.filterUserSearchInput(searchStore.userInput),
  };

  return Object.fromEntries(
    Object.entries(payload).filter(([key, value]) => key !== 'front' && value !== false)
  );
};

const fetchHomePromoted = async (options = {}) => {
  const payload = buildPromotedPayload();
  const limit = Object.keys(payload).length > 0 ? 10 : 2;
  const oldPromotedAnnouncementIds = options?.resetOldPromotedIds
    ? []
    : getDisplayedPromotedIds(
      searchStore.getPromotedSearchResult ?? [],
      searchStore.getFetchResult?.announcements ?? []
    );

  const response = await $fetch("/announcements/promoted-search-result", {
    method: "POST",
    headers: {
      token: runTimeConfig.public.token,
    },
    body: {
      ...payload,
      limit,
      oldPromotedAnnouncementIds,
    },
    baseURL: runTimeConfig.public.baseUrl,
  });

  const announcements = Array.isArray(response)
    ? response
    : response?.announcements ?? [];
  const uniquePromoted = getUniquePromotedAnnouncements(announcements);

  homePromotedAnnouncements.value = uniquePromoted;
  searchStore.setPromotedSearchResult(uniquePromoted);
};

const handleGoToSearchResults = async () => {
  searchStore.userInput = { ...searchStore.selectedInput };
  // Home -> filter: reset promoted history before requesting promoted cards.
  searchStore.clearPromotedSearchResult();
  await fetchHomePromoted({ resetOldPromotedIds: true });
  await searchStore.fetchAnnounce(1, dashStore.getUserProfil.id);
  if (typeof searchStore.getFetchResult?.totalCount === 'number') {
    searchStore.setAnnounceCount(searchStore.getFetchResult.totalCount);
  }
  await navigateTo('/voitures');
};

onBeforeMount(async () => {
  resetReady();
  try {
    const hasCachedAnnouncements = Boolean(searchStore.getFetchResult?.announcements?.length);
    const shouldSkipRefetch = hasCachedAnnouncements &&
      (isComingFromAnnouncementDetails() || consumeSkipRefetchFlag());

    if (shouldSkipRefetch) {
      hydrateHomePromotedFromCache();
      return;
    }

    // Always reload home results to avoid showing cached cards from local storage.
    searchStore.resetStoreValues();
    searchStore.searchResult = { totalCount: 0, announcements: [], filters: {} };
    await searchStore.fetchAnnounce(1, dashStore.getUserProfil.id);
    searchStore.setAnnounceCount(searchStore.getFetchResult.totalCount);
    await fetchHomePromoted({ resetOldPromotedIds: true });
  } finally {
    await nextTick();
    markReady();
  }
});

onMounted(() => {
  hydrated.value = true;
  document.documentElement.style.scrollBehavior = 'auto';
  if (runTimeConfig.public.clientBaseUrl === 'https://topauto.tn') {
    $fbq('track', 'PageView')
    $fbq('trackCustom', 'Page Accueil', {
      page_name: 'Accueil',
      page_type: 'home',
      locale: 'fr-TN'
    })
  }
})

</script>

<style lang="scss" scoped>
@import "../assets/styles/mixins.scss";

.landing-page-bg {
  height: 400px;
  position: relative;
}

.hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.landing-page-bg > .container-xl { position: relative; z-index: 1; }

.markIcon {
  font-size: 24px;

  @include screen-mobile-above {
    font-size: 32px;
  }
}

.small-width {
  width: 140px;
}

@include screen-laptop-below-xl {
  .circlesSvg {
    transform: rotate(90deg);
    margin: 20px 0px;
  }
}

.infoCards-container {
  li {
    @include screen-laptop-above-xl {
      max-width: 298px;
    }

    &:last-child {
      @include screen-laptop-above-xl {
        max-width: 247px;
      }
    }
  }
}

.home-title {
  line-height: 1.1;
  text-shadow: #0148E2 0px 0px 5px, #0148E2 0px 0px 10px, #0148E2 0px 0px 15px, #0148E2 0px 0px 20px, #0148E2 0px 0px 30px, #0148E2 0px 0px 40px, #0148E2 0px 0px 50px, #0148E2 0px 0px 75px;
}

/* Optimisations spécifiques à Safari */
@media not all and (min-resolution:.001dpcm) { 
  @supports (-webkit-appearance:none) {
    .landing-page-bg {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }
    
    .sticky-toolbar {
      position: -webkit-sticky;
    }
    
    /* Améliorer les performances de défilement */
    .page-container {
      -webkit-overflow-scrolling: touch;
    }
    
    /* Réduire l'intensité de l'animation pour Safari */
    .spinner-border {
      -webkit-animation: spinner-border 0.75s linear infinite;
      animation: spinner-border 0.75s linear infinite;
    }
    
    /* Optimiser le rendu des cartes */
    .card-fillters, .influo-cards {
      -webkit-font-smoothing: antialiased;
      transform: translateZ(0);
    }
  }
}

/* Réduire les repaints au scroll */
.sticky-toolbar {
  will-change: transform;
}

/* Empêcher le layout thrashing */
.fillter-card-container, .infoCards-container {
  content-visibility: auto;
}

/* Optimiser le rendu des images */
.bg-img {
  image-rendering: -webkit-optimize-contrast;
}

.gradient-border-btn {
  width: 236px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 6px 12px;
  font-size: 0.875rem;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: #0148E2 0px 0px 5px, #0148E2 0px 0px 10px, #0148E2 0px 0px 15px, #0148E2 0px 0px 20px, #0148E2 0px 0px 30px, #0148E2 0px 0px 40px, #0148E2 0px 0px 50px, #0148E2 0px 0px 75px;
}

.gradient-border-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 12px;
  padding: 2px;
  background: linear-gradient(270deg, #ff00ff, #00ffff, #ff00ff);
  background-size: 600% 600%;
  animation: gradientMove 5s ease infinite;
  -webkit-mask:
    linear-gradient(#FFF 0 0) content-box,
    linear-gradient(#FFF 0 0);
  -webkit-mask-composite: destination-out;
          mask-composite: exclude;
}

.gradient-border-btn:hover::before {
  animation-duration: 2s;
}

.gradient-border-btn::after {
  content: "";
  position: absolute;
  inset: 4px;
  background: #FFF;
  border-radius: 8px;
  z-index: -1;
}

@keyframes gradientMove {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

</style>

